export function findInsertIndex<T>(
    itemToInsert: T,
    sortedArray: T[],
    objectComparer: (arrayItem1: T, arrayItem2: T) => number
): number {
    let middle: number = 0;
    let start: number = 0;
    let end: number = sortedArray ? sortedArray.length - 1 : 0;

    while (start <= end) {
        middle = Math.floor((start + end) / 2);
        let compareResult = objectComparer(itemToInsert, sortedArray[middle]);
        if (compareResult == 0) {
            return middle;
        } else if (compareResult < 0) {
            end = middle - 1;
            if (middle <= start) {
                return Math.max(start, end);
            }
        } else {
            start = middle + 1;
            if (middle >= end) {
                return start;
            }
        }
    }

    return middle;
}
